import React, { useState } from "react";
import { VerifyP2PPayment } from "../../../pages";
import * as yup from "yup";
import { MimaToastUtil } from "../../../components";
import constant from "../../../utils/constant";
import { MoneyExController } from "../../../controllers";

const VerifyP2PPaymentContainer = ({ closeModal, singleItem }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = () => {
    return yup.object().shape({
      amount: yup.string().required("Enter amount"),
      buyerPaymentDateTime: yup.string().required("Enter payment date/time"),
      buyerStatus: yup.string().required("Select Status"),
    });
  };

  const statusData = [
    { key: "PAID", value: "PAID" },
    { key: "FALSE-PAYMENT", value: "FALSE-PAYMENT" },
  ];

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      amount: values.amount,
      buyerPaymentDateTime: values.buyerPaymentDateTime,
      buyerStatus: values.buyerStatus,
      moneyExOrderId: singleItem._id,
      note: values.note,
    };

    const { status, errorMessage } =
      await MoneyExController.verifyP2PPayment(payload);
    if (status === constant.Success) {
      MimaToastUtil.success({ message: "Payment verified successfully" });
      setLoading(false);
      return closeModal();
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };
  return (
    <VerifyP2PPayment
      closeModal={closeModal}
      singleItem={singleItem}
      statusData={statusData}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      loading={loading}
    />
  );
};

export default VerifyP2PPaymentContainer;
